import { config } from "../utils/config";
import { omniAxios } from "../utils/axios";

export function restUCompanyGetCompanyInfo() {
  return omniAxios({
    url: config.restUCompanyGetCompanyInfoPath,
    method: "get",
    params: {},
    isTwoPointZeroInterfaceApi: true,
  });
}

// 获取是否显示定制版会员中心入口
export function commonCusApiHomepageIdTypeGw({ id }) {
  return omniAxios({
    url: config.commonCusApiHomepageIdTypeGwPath,
    method: "get",
    params: {
      id,
    },
    isApiPath: true,
    withCredentials: false,
  });
}

export function restUserApiHomepageLogout() {
  return omniAxios({
    url: config.restUserApiHomepageLogoutPath,
    method: "get",
    params: {},
    isApiPath: true,
  });
}

export function restPayPayDialogInfoNeedBuyMoreDialog(params) {
  return omniAxios({
    url: config.restPayPayDialogInfoNeedBuyMoreDialogPath,
    method: "post",
    params,
    isTwoPointZeroInterfaceApi: true,
  });
}
// 公共埋点
export function userBehaviorInsertRecordWebsite(params) {
  return omniAxios({
    url: config.userBehaviorInsertRecordWebsitePath,
    method: "post",
    params,
    withCredentials: false,
    isTracker: true,
  });
}
